export const updateTrainerPassword = (data: { [key: string]: any }) => {
  return {
    method: "PUT",
    url: `${process.env.REACT_APP_ADMIN_API_URL}/trainer/update-password`,
    data,
  };
};

export const updateTrainerRoles = (
  data: { [key: string]: any },
  userId: string | undefined
) => {
  return {
    method: "PUT",
    url: `${process.env.REACT_APP_ADMIN_API_URL}/trainer/roles`,
    data,
    headers: {
      "x-user-id": userId,
    },
  };
};
